import CryptoJS from "crypto-js";

const SECRET_KEY = "a1d4f6b9c3e7d2f5a8c1e9b4d6f2a3c9"; // keep this in .env
export const getQuestionareSubmitted = () => {
  try {
    return {
      questionareSubmitted: JSON.parse(
        localStorage.getItem("questionareSubmitted")
      ),
    };
  } catch {
    return localStorage.getItem("questionareSubmitted"); // fallback if not JSON
  }
};

// Encrypt data
export const encryptDataFun = (data) => {
  try {
    // console.log("1111111111111111", data);
    const stringData = JSON.stringify(data); // convert object → string

    return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

// Decrypt data
export const decryptDataFun = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString); // convert string → object
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
